import EL from '../../EL/EL.js';
import SVGPATH from '../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGPATH.js';
import SVGGROUP from '../../DOM/svg/SVGOBJECT/SVGGROUP.js';
import SVGSHAPE from '../../DOM/svg/SVGOBJECT/SVGSHAPE.js';
import { HTMLELEMENT } from '../../../enums/HTMLELEMENT.js';
import { SVGASPECTRATIOS } from '../../../enums/SVGASPECTRATIOS.js';
import { SVGELEMENT } from '../../../enums/SVGELEMENT.js';
import SVGDEFS from '../../DOM/svg/SVGOBJECT/SVGDEFS.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
import SVGTEXT from '../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGTEXT.js';
// Model Structure
export const svgAttr = makeAttrStruct([
    ['viewBox', '0 0 100 100'],
    ['width', '100%'],
    ['height', '100%'],
    ['fill', 'currentColor'],
    ['stroke', 'none'],
    ['stroke-width', '64'],
    ['stroke-miterlimit', '10'],
    ['stroke-linecap', 'round'],
    ['stroke-linejoin', 'round'],
    ['style'],
    ['preserveAspectRatio', SVGASPECTRATIOS.XMIN_YMIN_MEET],
    ['xmlns', 'http://www.w3.org/2000/svg']
]);
export const svgData = makeDataStruct([
    ['children']
]);
export const svgModel = makeStruct([
    ['attributes', svgAttr],
    ['data', svgData]
]);
// Simplified Model
export function svg(children, attr) {
    return {
        attributes: attr || svgAttr(),
        data: svgData(children || [])
    };
}
/** Creates a scaleable vector graphic
    @see http://xahlee.info/js/js_scritping_svg_basics.html
*/
export default class SVG extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.SVG, model);
        this.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.buildSVG(model);
    }
    buildSVG(model) {
        if (!model || !model.data || !Array.isArray(model.data.children)) {
            console.warn('SVG.buildSVG: Invalid model or missing data.children', model);
            return;
        }
        model.data.children.forEach((el) => {
            switch (el.element) {
                case SVGELEMENT.G: {
                    this.addGroup(el);
                    break;
                }
                case SVGELEMENT.DEFS: {
                    const e = el;
                    this.addDefs(e);
                    break;
                }
                case SVGELEMENT.PATH: {
                    const e = el;
                    this.addPath(e);
                    break;
                }
                case SVGELEMENT.LINE: {
                    this.addShape(SVGELEMENT.LINE, el);
                    break;
                }
                case SVGELEMENT.RECT: {
                    this.addShape(SVGELEMENT.RECT, el);
                    break;
                }
                case SVGELEMENT.CIRCLE: {
                    this.addShape(SVGELEMENT.CIRCLE, el);
                    break;
                }
                case SVGELEMENT.ELLIPSE: {
                    this.addShape(SVGELEMENT.ELLIPSE, el);
                    break;
                }
                case SVGELEMENT.POLYGON: {
                    this.addShape(SVGELEMENT.POLYGON, el);
                    break;
                }
                case SVGELEMENT.POLYLINE: {
                    this.addShape(SVGELEMENT.POLYLINE, el);
                    break;
                }
                case SVGELEMENT.IMAGE: {
                    this.addShape(SVGELEMENT.IMAGE, el);
                    break;
                }
                case SVGELEMENT.TEXT: {
                    this.addText(el);
                    break;
                }
                // case SVGELEMENT.TSPAN: {
                // 	console.log('SVGTSPAN', el);
                // 	this.addShape(SVGELEMENT.TSPAN, el as SVGTSpanElementModel);
                // 	break;
                // }
                default:
                    console.warn('SVG.setPaths: Undefined child element', el);
            }
        });
    }
    createElement() {
        const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        return el;
    }
    /** Adds a group to this SVG Element */
    addGroup(model) {
        return this.addChild(new SVGGROUP(this, model));
    }
    /** Adds a path to this SVG Element */
    addPath(model) {
        return this.addChild(new SVGPATH(this, model));
    }
    /** Adds a shape to this SVG Element */
    addShape(type, model) {
        return this.addChild(new SVGSHAPE(this, type, model));
    }
    /** Adds a text element to this SVG Element */
    addText(model) {
        return this.addChild(new SVGTEXT(this, model));
    }
    /** Adds a defs element to this SVG Element */
    addDefs(model) {
        return this.addChild(new SVGDEFS(this, model));
    }
}
export { EL, SVGGROUP, SVGPATH, SVGSHAPE, SVGDEFS };
